<template>
  <div :class="$style.wrapper">
    <div
      :class="[$style.image, { [$style.locked]: !active }]"
      :style="{ backgroundImage: active ? `url(${image})` : null }"
    ></div>
    <div :class="$style.title">{{title}}</div>
  </div>
</template>
<script>
export default {
  name: 'LessonCard',
  props: {
    title: String,
    active: Boolean,
    image: String,
  },
}
</script>
<style lang="scss" module>
@import './LessonCard.scss';
</style>
